import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { Sitemap } from 'landings/sitemap';
import { RemoteProps } from './widgets-types';

export const SitemapRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <Sitemap />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
